import { __awaiter, __generator } from "tslib";
import { queryCache } from '@office-start/data-fetching';
import { fetchRecent } from './fetchRecent';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function prefetchEdgeworthRecentData(apiOptions, throwOnError) {
    if (throwOnError === void 0) { throwOnError = false; }
    return __awaiter(this, void 0, void 0, function () {
        var query;
        return __generator(this, function (_a) {
            query = ['EdgeworthData', "Recent" /* QuerySubtype.Recent */];
            return [2 /*return*/, queryCache.prefetchQuery(query, function () { return fetchRecent(apiOptions); }, {
                    throwOnError: throwOnError,
                })];
        });
    });
}
//# sourceMappingURL=prefetchEdgeworthRecentData.js.map